import { useEffect, useRef, useState } from "react";
import NiceModal from "@ebay/nice-modal-react";
import ModalBase from "modals/base/ModalBase";


const ProductDetailModal = NiceModal.create(
    (props, ref) => {
        const modal = useRef();
        const [withHeader, withFooter] = [true, false];
        const [width, height] = ["fit-content", "max(70vh, 40vw)"];
        const withCloseButton = true;
        const clickOutsideToClose = true;
        const title = props.title;
        const buttonText = "close";

        return (
            <ModalBase ref={modal} width={width} height={height} withHeader={withHeader} withFooter={withFooter} withCloseButton={withCloseButton} clickOutsideToClose={clickOutsideToClose} title={title} buttonText={buttonText}>
                <img style={{height:"calc(100% - 50px)"}} src={props.image}/>
            </ModalBase>
        );
    }
);

export default ProductDetailModal;